<mat-accordion>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title *ngIf="!hideTitle">
        <span class="PillarName">{{('uishared.pillars.' + pillar.name) | transloco}}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div *ngFor="let tocKeyword of pillar.tocKeywords;">
      <ul class="List List-firstLevel">
        <h2 *ngIf="tocKeyword.name && tocKeyword.name != ' '">{{tocKeyword.name}}</h2>
        <li class="Teaser-item" [class.HasIndicator]="dateService.isLessThanOrEqualToDifferenceFromNow(teaser.publicationDate, newIndicatorDays)" *ngFor="let teaser of tocKeyword.documentTeasers;">
          <span *ngIf="teaser.title">
            <a [routerLink]="'../' + teaser.uniqueNumber">{{teaser.title}}</a>
            <span *ngIf="dateService.isLessThanOrEqualToDifferenceFromNow(teaser.publicationDate, newIndicatorDays)">
              &nbsp;({{dateService.getDifferenceInDaysFromNow(teaser.publicationDate)}} day<span *ngIf="dateService.getDifferenceInDaysFromNow(teaser.publicationDate) > 1">s</span> ago)
            </span>
        </span>
          <ul *ngIf="teaser.collectionHighlights.highlights.length > 0" class="Sublist List--small List-secondLevel">
            <li class="Hightlight-item" *ngFor="let highlight of teaser.collectionHighlights.highlights;">{{highlight.value}}</li>
          </ul>
        </li>
      </ul>
    </div>
  </mat-expansion-panel>
</mat-accordion>
